export const DEFAULT_TICK_PERCENT = 50;
